import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LegalKvkkAydinlatma: React.FC = () => {
  const { t } = useTranslation();
  const processingPurposes = t('legal.kvkk.processingPurposesItems', { returnObjects: true }) as string[];
  const principles = t('legal.kvkk.principlesItems', { returnObjects: true }) as string[];
  const collectedData = t('legal.kvkk.collectedDataItems', { returnObjects: true }) as string[];
  const collectionMethods = t('legal.kvkk.collectionMethodsItems', { returnObjects: true }) as string[];
  const rights = t('legal.kvkk.rightsItems', { returnObjects: true }) as string[];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">LotusRecruiter</Link>
          <Link to="/login" className="text-sm text-lotus-gold font-semibold">
            {t('legal.customerLogin')}
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-md p-8 space-y-8">
          <div>
            <p className="text-sm uppercase tracking-widest text-gray-400 font-semibold">{t('legal.kvkk.label')}</p>
            <h1 className="text-3xl font-bold text-gray-900 mt-2">{t('legal.kvkk.title')}</h1>
            <p className="mt-4 text-gray-600 leading-relaxed">
              {t('legal.kvkk.intro')}
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.dataControllerTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.dataControllerText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.processingPurposesTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.processingPurposesIntro')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              {processingPurposes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.legalBasisTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.legalBasisText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.principlesTitle')}</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              {principles.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.securityTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.securityText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.collectedDataTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.collectedDataIntro')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              {collectedData.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.collectionMethodsTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.collectionMethodsIntro')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              {collectionMethods.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.retentionTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.retentionText')}
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-2 text-sm text-gray-700">
              <p className="font-medium text-gray-900">{t('legal.kvkk.retentionDetails')}</p>
              <ul className="list-disc list-inside space-y-1">
                <li>{t('legal.kvkk.retentionDetail1')}</li>
                <li>{t('legal.kvkk.retentionDetail2')}</li>
                <li>{t('legal.kvkk.retentionDetail3')}</li>
                <li>{t('legal.kvkk.retentionDetail4')}</li>
                <li>{t('legal.kvkk.retentionDetail5')}</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.withdrawalTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.withdrawalText')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-1">
              <li>{t('legal.kvkk.withdrawalItem1')}</li>
              <li>{t('legal.kvkk.withdrawalItem2')}</li>
              <li>{t('legal.kvkk.withdrawalItem3')}</li>
              <li>{t('legal.kvkk.withdrawalItem4')}</li>
              <li>{t('legal.kvkk.withdrawalItem5')}</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.accountDeletionTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.accountDeletionText')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-1">
              <li>{t('legal.kvkk.deletionItem1')}</li>
              <li>{t('legal.kvkk.deletionItem2')}</li>
              <li>{t('legal.kvkk.deletionItem3')}</li>
              <li>{t('legal.kvkk.deletionItem4')}</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.transferTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.transferText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.rightsTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.rightsIntro')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              {rights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.exerciseTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.exerciseIntro')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>{t('legal.kvkk.addressLabel')} Merkez Mah. 52072 Sk. No:7 İç Kapı No:10 Mezitli/Mersin</li>
              <li>{t('legal.kvkk.emailLabel')} info@aiotech.tr</li>
              <li>{t('legal.kvkk.phoneLabel')} +90 533 614 67 74</li>
            </ul>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.exerciseNote')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.kvkk.contactTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.kvkk.contactIntro')}
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>{t('legal.kvkk.emailLabel')} info@aiotech.tr</li>
              <li>{t('legal.kvkk.phoneLabel')} +90 533 614 67 74</li>
              <li>{t('legal.kvkk.addressLabel')} Merkez Mah. 52072 Sk. No:7 İç Kapı No:10 Mezitli/Mersin</li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  );
};

export default LegalKvkkAydinlatma;
